export const APP_VERSION = '1.3.2';
